import React from 'react';
import { connect } from 'react-redux';

import { getCompliancesComparison } from '../actions/v2_tags'
import * as tagsConstants from '../constants/tags'

import TrainingComplianceCharts from './components/v2_training_compliance_charts'
import AppComponent from './components/app_component'

class CountryComparison extends AppComponent {
  constructor(props){
    super(props);

    this.state = {
      requestParams: {
        context: 'regions',
        dashboard_type: 'average_ratings'
      },
      loading: false
    }

  }

  // FUNCTIONS FOR DATA MANIPULATION
  componentDidMount() {
    this.props.getCompliancesComparison(this.state.requestParams)
  }

  componentWillReceiveProps(nextProps){
    this.handleV2TagsNextProps(nextProps)
  }

  handleV2TagsNextProps = (nextProps) => {
    if (this.props.v2tags.requestType === nextProps.v2tags.requestType) return
    var { complianceRatings, requestType } = nextProps.v2tags

    if (requestType===tagsConstants.GET_COMPLIANCES_COMPARISON_SUCCESS){
      this.setState({
        complianceRatings: complianceRatings,
        loading: false
      })
      this.hideLoadingMessage()
    }
    else {
      this.setState({
        loading: true
      })
      this.showLoadingMessage()
    }
  }

  setView = (view) => {
    var {requestParams} = this.state
    requestParams.dashboard_type = view
    this.setState({requestParams})
    this.props.getCompliancesComparison(requestParams)
  }

  render() {
    return (
      <div className='dashboard'>
        <TrainingComplianceCharts
          loading={this.state.loading}
          complianceRatings={this.state.complianceRatings}
          setView={this.setView}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    v2tags: state.v2tags
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCompliancesComparison: (params) => {
      return dispatch(getCompliancesComparison(params))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CountryComparison);



// WEBPACK FOOTER //
// ./src/views/country_comparison.js